/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	// Import videoUtils

	var videoUtils = __webpack_require__(325);

	document.addEventListener('DOMContentLoaded', function () {
	    var pageDesignerUI = document.querySelector('.cc-editorialMode, .cc-preview');
	    var videoElements = document.querySelectorAll('.js-videoWrapper');

	    videoElements.forEach(function (videoElement) {
	        var iframeSrc = '';

	        // Passing values ​​via ISML template
	        var videoID = videoElement.getAttribute('data-video-id');
	        var videoIDMobile = videoElement.getAttribute('data-video-id-mobile');

	        // Ensuring that it is null if it is invalid
	        videoID = videoID === null || videoID === 'null' || videoID === '' ? null : videoID;
	        videoIDMobile = videoIDMobile === null || videoIDMobile === 'null' || videoIDMobile === '' ? null : videoIDMobile;

	        // Sanitize the videoID using videoUtils
	        var sanitizedID = videoUtils.sanitizeVideoID(videoID);
	        var sanitizedIDMobile = videoUtils.sanitizeVideoID(videoIDMobile);

	        // Generate iframe source if sanitizedID is valid
	        if (sanitizedID || sanitizedIDMobile) {
	            if (window.matchMedia("(max-width: 767.98px)").matches && videoIDMobile && !pageDesignerUI) {
	                iframeSrc = 'https://player.vimeo.com/video/' + sanitizedIDMobile + '?autoplay=1&loop=1&autopause=0&muted=1&background=1';
	            } else {
	                iframeSrc = 'https://player.vimeo.com/video/' + sanitizedID + '?autoplay=1&loop=1&autopause=0&muted=1&background=1';
	            }

	            videoElement.insertAdjacentHTML('afterbegin', '<iframe class="cc-video" src="' + iframeSrc + '" width="100%" frameborder="0" allow="autoplay" allowfullscreen></iframe>');
	        }
	    });
	});

/***/ }),

/***/ 325:
/***/ (function(module, exports) {

	'use strict';

	var videoUtils = {
	    sanitizeVideoID: function sanitizeVideoID(videoID) {
	        var videoIDPattern = /^[0-9]+$/;
	        var sanitizedID = videoID ? videoID.replace(/[^0-9]/g, '') : null;
	        return sanitizedID && videoIDPattern.test(sanitizedID) ? sanitizedID : null;
	    }
	};

	module.exports = videoUtils;

/***/ })

/******/ });